import React, { useState, useRef, useEffect } from 'react';
import { isEmpty, isNil } from 'ramda';

import topknot from 'assets/images/topknot.png';
import { useEvieChatContext } from '../EvieChatProvider';

import WelcomeMessage from '../WelcomeMessage';
import ChatInput from '../ChatInput';
import Messages from '../Messages';
import TestResult from '../TestResult';
import MessagesLeft from '../MessagesLeft';

import './chat-dock.scss';

const AssistantContent = () => {
  const { messagesLeft, unlimited, chatSessions = [], isAwaitingResponse, isAwaitingGreeting, isNative } =
    useEvieChatContext();
  const allMessages = chatSessions
    .flatMap((session) => session.messages)
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  const isEmptyMessages = isEmpty(allMessages);

  const isFirstRender = useRef(true);
  const [userMessage, setUserMessage] = useState('');

  useEffect(() => {
    const behavior = isFirstRender.current ? 'instant' : 'smooth';
    isFirstRender.current = false;
    window.scrollTo({ top: document.body.scrollHeight, behavior });
  }, [allMessages.length, isAwaitingResponse]);

  return (
    <section className="evie-assistant">
      <img src={topknot} alt="UI - topknot" className="evie-assistant_topknot" />
      <div className={`chat-dock ${isNative ? 'native-chat-dock' : ''}`}>
        {!isNil(messagesLeft) || !unlimited ? <MessagesLeft /> : null}
        <ChatInput updateUserMessage={setUserMessage} isEmptyMessages={isEmptyMessages} />
      </div>
      <TestResult />
      {isEmptyMessages && !isAwaitingResponse && !isAwaitingGreeting ? (
        <WelcomeMessage />
      ) : (
        <Messages messages={allMessages} userMessage={userMessage} updateUserMessage={setUserMessage} />
      )}
    </section>
  );
};

export default AssistantContent;
